import { styled } from '@mui/material';

export const BusinessVerticalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #FFF;
`;


export const BusinessVerticalContentWrapper = styled('div')`
  display: flex;
  width: 100%;
  position: relative;
  padding: 0px 80px;
  z-index: 1;
  &::after {
    content: '';
    position: absolute;
    bottom: -20px; 
    left: 0;
    right: 0;
    height: 20px; 
    background: linear-gradient(180deg, #AFB1B4 -15.07%, rgba(196, 198, 200, 0.39) 9.43%, rgba(255, 255, 255, 0.00) 52.86%);
    opacity: 0.6;
    z-index: -1; 
    mix-blend-mode: multiply; 
    background-blend-mode: multiply;

  }
  @media (max-width: 768px) {
    flex-direction: ${({ isSales }) => (isSales ? 'row' : 'column')};
    padding: ${({ isSales }) => (isSales ? '30px 5px 0px' : '20px 20px 0px;')};

  }
`;


export const BusinessVerticalLeftSection = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ isSales }) => (isSales ? '0' : '8vw')};
  align-items: start;
  width: ${({ isSales }) => (isSales ? '60%' : '45%')};
  padding: 60px 0px;
  @media (max-width: 768px) {
    padding: 0; 
    width: 100%;
    .titleText {
      display: none;
    }
  }
`;

export const BusinessVerticalIconContainer = styled('div')`
  display: flex;
  align-items: end;
  gap: 10px;
  @media (max-width: 768px) {
  padding-left: 20px;
  }
`;

export const BusinessVerticalIconImg = styled('img')`
  width: fit-content;
  height: 86px;
  @media (max-width: 768px) {
    width: 50px;
    height: auto;
    margin: 0 auto; 
    display: block;
  }
`;

export const BusinessVerticalTitleImage = styled('img')`
  width: 20vw;
  margin: 5vw 0px ;
  @media (max-width: 768px) {
    width: 100%; 
    margin: 10vw auto;

  }
  @media (max-width: 345px) {
    width: 80%; 

  }
  @media (max-width: 320px) {
    width: 70%; 
    margin-right:20vw;
  }
  @media (max-width: 285px) {
    width: 60%; 
  }
`;

export const BusinessVerticalIconText = styled('span')`
  font-size: 1.5rem;/*24px */
  font-family: "Radikal";
  font-weight: 500;
  color: #414042;
  align-items: end;
`;

export const BusinessVerticalTitle = styled('h1')`
  font-size: 2.625rem;/*42px */
  font-family: "Montserrat";
  font-weight: 600;
  color: #414042;
  @media (max-width: 1280px) {
    font-size: 2rem;/*32px */

  }
  @media (max-width: 768px) {
    font-size: 1.5rem;/*24px */
    margin-top:3.5vw;

  }
`;

export const BusinessVerticalRightSection = styled('div')`
  width: ${({ isSales }) => (isSales ? '40%' : '60%')};
  display: flex;
  @media (max-width: 768px) {
    width: 100%; 
    justify-content: center; 
  }
`;

export const BusinessVerticalRightSectionImg = styled('img')`
  width: ${({ isSales }) => (isSales ? '40vw' : '50vw')};
  height: auto;
  ${'' /* margin: 0 auto; */}
  margin:${({ isSales }) =>(isSales ? '2vw auto 0px' : '0 auto')};
  @media (max-width: 768px) {
    width: ${({ isSales }) => (isSales ? '70vw' : '80vw')};
    margin: ${({ isFinance }) => (isFinance ? '5vw auto 0px' : '')};  /* Extra margin for Finance */

  }
  @media (max-width: 450px) {
    margin-left:${({ isSales }) =>(isSales ? '-10vw' : '')};
    margin-top:${({ isSales }) =>(isSales ? '15vw' : '')};


  }
  @media (max-width: 350px) {
    margin-left:${({ isSales }) =>(isSales ? '-15vw' : '')};
  } 
  @media (max-width: 320px) {
    margin-left:${({ isSales }) =>(isSales ? '-20vw' : '')};
  } 
  @media (max-width: 285px) {
    margin-left:${({ isSales }) =>(isSales ? '-25vw' : '')};
  } 
`;

export const BusinessVerticalDescription = styled('p')`
  font-size: 1.125rem;/*18px */
  color: #231F20;
  line-height: 24px;
  font-family: "Radikal";
  text-align: center;
  margin-top: 40px;
  max-width: 85%;
  width: 100%;
  align-self: center !important;
  @media (max-width: 768px) {
    font-size: 1rem;/*16px */
    margin-top: 20px;
  }
  @media (max-width: 768px) {
    font-size: 1rem;/*16px */
    margin-top: 20px;
  }
  @media (max-width: 325px) {
    font-size: 0.813rem;/*13px */
    margin-top: 20px;
  }
`;

export const BusinessVerticalMobileTitleContainer = styled('div')`
  display: none;

  @media (max-width: 768px) {
    display: block;
    text-align: center;
    padding:4vw;
  }
`;



/*BVertical.jsx */


export const BVerticalContainer = styled("div")`
  padding: 4vw 4.5vw 0vw;/*80px */
  @media (max-width: 768px) {
    padding: 10vw 4vw 0vw;
  }
`;

export const BVerticalRow = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4vw;

  @media (max-width: 768px) {
    flex-direction: column !important; 
    text-align: center;
  }
`;

export const BVerticalTextWrapper = styled("div")`
  width: 55%;
  text-align: left;
  ${({ reverse }) => reverse && `
    text-align: end;
  `}

  @media (max-width: 768px) {
    width: 100%;
    order: 2;
    text-align: center;
  }
`;

export const BVerticalTitle = styled("span")`
  font-size: 2.625rem;/*42px*/
  font-family: Montserrat;
  font-weight: 600;
  color:#414042;
  @media (max-width: 1280px) {
    font-size: 2rem;
  }
  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
  @media (max-width: 375px) {
    font-size: 1.313rem;/*21px*/
  }
`;

export const BVerticalSubTitle = styled("p")`
fontsize:1.5rem;/*24px */
  font-weight: 400;
  color: #1D00C4; 
  font-family: Radikal;
  margin-top: 2.083vw;/*30px*/
  margin-bottom: 3.542vw;/*51px*/
  @media (max-width: 1280px) {
    font-size: 1rem; 
    margin-top: 1.4vw;
    margin-bottom: 1vw;
  }
  @media (max-width: 768px) {
    font-size: 1.2rem; 
    margin-top: 5vw;
  }
  @media (max-width: 375px) {
    font-size: 1rem;/*16px*/
  }
`;

export const BVerticalDescription = styled("p")`
  font-size: 1.125rem;/*18px*/
  color: #231f20;
  font-family: Radikal;
  font-weight: 400;
  line-height: 24px; /* 133.333% */
  @media (max-width: 1280px) {
    font-size: 0.9rem;
  }
  @media (max-width: 768px) {
    font-size: 1rem;/*13px*/
    padding:4vw 4vw;
  }
  @media (max-width: 375px) {
    font-size: 0.9rem;/*13px*/
    padding:4vw 6vw;
  }
`;

export const BVerticalImageWrapper = styled("img")`
  width: 40%;
  max-height: 400px; 
  object-fit: contain;
  @media (max-width: 1280px) {
    max-height: 350px; 
  }
  @media (max-width: 768px) {
    width: 70%;
    margin-bottom: 2vw;
    max-height: 250px; 
    order: 1; 
    margin-bottom: 6vw;

  }
  @media (max-width: 375px) {
    width: 75%;
    max-height: 200px; 
  }
`;


export const AppointmentButtonWrapper = styled("div")`
  display: flex;
  justify-content: center;
  margin-bottom: 50px; 
`;